import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RegisterComponent } from './pages/register/register.component';
import { HomeComponent } from './pages/home/home.component';
import { ResetComponent } from './pages/reset/reset.component';
import { HeaderComponent } from './pages/header/header.component';
import { FooterComponent } from './pages/footer/footer.component';
import { AhorrosComponent } from './pages/ahorros/ahorros.component';
import { CarteraComponent } from './pages/cartera/cartera.component';
import { ServiciosComponent } from './pages/servicios/servicios.component';
import { CodeudoresComponent } from './pages/codeudores/codeudores.component';
import { TarjetaComponent } from './pages/tarjeta/tarjeta.component';
import { SimuladorComponent } from './pages/simulador/simulador.component';
import { NgxPaginationModule } from "ngx-pagination";
import { SeguridadComponent } from './pages/seguridad/seguridad.component';
import { DocumentosComponent } from './pages/documentos/documentos.component';
import { SolicitudesComponent } from './pages/solicitudes/solicitudes.component';
import { DescuentosComponent } from './pages/descuentos/descuentos.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AlertModule } from "ngx-bootstrap/alert";
import { MatDialogModule } from '@angular/material/dialog';
import { ThousandsPipe } from '../pipe/formateaPesos.pipe';
import { PercentPipe } from '../pipe/formateaPorcent.pipe';
import { ActualizacionComponent } from './pages/actualizacion/actualizacion.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

//importancian angular material
import {MatIconModule} from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { DireccionesComponent } from './direcciones/direcciones.component';
import { PolizasComponent } from './pages/polizas/polizas.component';
import { MatNativeDateModule } from '@angular/material/core';
import { SeguroComponent } from './pages/seguro/seguro.component';
import { PagosComponent } from './pages/pagos/pagos.component';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFileUploadModule } from 'angular-material-fileupload';
import { SolicitudesNewComponent } from './pages/solicitudes-new/solicitudes-new.component';
import { UserService } from './services/user.service';
import { RecogeCreditosComponent } from './modales/recoge-creditos/recoge-creditos.component';
import { ViewTrackingComponent } from './modales/view-tracking/view-tracking.component';
import { PagarePrincipalComponent } from './modales/pagare-principal/pagare-principal.component';
import { AceptaSolicitudComponent } from './modales/acepta-solicitud/acepta-solicitud.component';
import { DecsisCloudComponent } from './pages/decsis-cloud/decsis-cloud.component';
import { ManualesComponent } from './pages/manuales/manuales.component';
import { CircularesComponent } from './pages/circulares/circulares.component';
import { ValidAfiliacionComponent } from './pages/valid-afiliacion/valid-afiliacion.component';
import { AfiliacionComponent } from './pages/afiliacion/afiliacion.component';
import { SolicitudSimuladorComponent } from './modales/solicitud-simulador/solicitud-simulador.component';
import { SolicitudRelampagoComponent } from './modales/solicitud-relampago/solicitud-relampago.component';
import { CodeudoresExternosComponent } from './modales/codeudores-externos/codeudores-externos.component';
import { TotalesComponent } from './pages/totales/totales.component';
import { VotacionesComponent } from './pages/votaciones/votaciones.component';

//importaciones primeng
import { MessageService } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { FileUploadModule } from 'primeng/fileupload';
import {CardModule} from 'primeng/card';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import { InputTextModule } from "primeng/inputtext";
import { ModalVotacionComponent } from './modales/modal-votacion/modal-votacion.component';
//import {SplitterModule} from 'primeng/splitter';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import { MovimientosComponent } from './modales/movimientos/movimientos.component';
import { SolicitudesServiciosComponent } from './pages/solicitudes-servicios/solicitudes-servicios.component';
import { PseFsvComponent } from './pages/pse-fsv/pse-fsv.component';
import { Page404Component } from './pages/page404/page404.component';
import { ConfirmPseComponent } from './pages/confirm-pse/confirm-pse.component';
import { InfoCodextComponent } from './pages/info-codext/info-codext.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    HomeComponent,
    ResetComponent,
    HeaderComponent,
    FooterComponent,
    AhorrosComponent,
    CarteraComponent,
    ServiciosComponent,
    CodeudoresComponent,
    TarjetaComponent,
    SimuladorComponent,
    SeguridadComponent,
    DocumentosComponent,
    SolicitudesComponent,
    DescuentosComponent,
    ActualizacionComponent,
    DireccionesComponent,
    PolizasComponent,
    PercentPipe,
    ThousandsPipe,
    SeguroComponent,
    PagosComponent,
    SolicitudesNewComponent,
    RecogeCreditosComponent,
    ViewTrackingComponent,
    PagarePrincipalComponent,
    AceptaSolicitudComponent,
    DecsisCloudComponent,
    ManualesComponent,
    CircularesComponent,
    ValidAfiliacionComponent,
    AfiliacionComponent,
    SolicitudSimuladorComponent,
    SolicitudRelampagoComponent,
    CodeudoresExternosComponent,
    TotalesComponent,
    VotacionesComponent,
    ModalVotacionComponent,
    MovimientosComponent,
    SolicitudesServiciosComponent,
    PseFsvComponent,
    Page404Component,
    ConfirmPseComponent,
    InfoCodextComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatStepperModule,
    MatSelectModule,
    MatDatepickerModule,
    MomentDateModule,
    MatRadioModule,
    MatButtonModule,
    MatNativeDateModule,
    MatFileUploadModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    FileUploadModule,
    DynamicDialogModule,
    CardModule,
    InputTextModule,
    MatIconModule,
    MatCardModule,
    MatExpansionModule,
    AlertModule.forRoot()
  ],
  providers: [
    MessageService,
    UserService,
    DialogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
